import { buildNavigationUrl } from "../../../util/buildNavigationUrl";
const EXHIBITION_LIST_CONTEXT_KEYS = [
  "listId",
  "imageListId",
  "workingListId",
  "imageWorkingListId",
];

const getExhibitionListContext = search => {
  const query = new URLSearchParams(search);

  return Object.fromEntries(
    EXHIBITION_LIST_CONTEXT_KEYS.flatMap(key => {
      const value = query.get(key);
      return value ? [[key, value]] : [];
    }),
  );
};

const buildExhibitionListUrl = ({ listContext = {}, status = "all" } = {}) => {
  const query = new URLSearchParams(
    status && status !== "all" ? { status } : {},
  );

  EXHIBITION_LIST_CONTEXT_KEYS.forEach(key => {
    if (listContext[key]) query.set(key, listContext[key]);
  });

  return buildNavigationUrl("/exhibition", query);
};

const buildExhibitionNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) =>
  buildNavigationUrl(
    `/exhibition/${recordId}/${activeSubPage || "details"}`,
    buildExhibitionListUrl({
      listContext,
      status,
    }).split("?")[1] || "",
  );

export {
  EXHIBITION_LIST_CONTEXT_KEYS,
  buildExhibitionListUrl,
  buildExhibitionNavigationTargetUrl,
  getExhibitionListContext,
};
